 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about~privacy":"about~privacy","about":"about","privacy":"privacy","account":"account","btc-ghs~dashboard":"btc-ghs~dashboard","btc-ghs":"btc-ghs","dashboard":"dashboard","eth-xof":"eth-xof","pm-cfa":"pm-cfa","register":"register","exchange":"exchange","faq":"faq","funds":"funds","home":"home","terms":"terms"}[chunkId]||chunkId) + "." + {"about~privacy":"0fbb308c","about":"246a05f6","privacy":"73c07534","account":"1973427a","chunk-0ed068c3":"a82bbf0f","chunk-71fbe8a7":"69023d86","chunk-9e48a706":"7ecd3ed2","chunk-c3a6b34c":"0d90cbc4","chunk-747bbab8":"0b299966","btc-ghs~dashboard":"c386ce6b","btc-ghs":"2165a665","dashboard":"f4573367","eth-xof":"e9b7d54d","pm-cfa":"f08e9fbd","register":"486ffa4b","exchange":"53e45f5f","chunk-d036161e":"af0ed63a","faq":"ff1c3c95","funds":"aa5de8ed","home":"9e4e92e8","terms":"d3e663b7","chunk-608a2038":"7c38e053","chunk-586e5fad":"1251fb8c","chunk-2d237773":"cde966a8","chunk-74e97a69":"4911f1e0","chunk-9d75d2e6":"a880db4a","chunk-9e6a327e":"cf3e00b0","chunk-221b05e2":"57c6266e","chunk-0f60b37e":"d24dc3ab","chunk-7b0a01d1":"60c4c131","chunk-140e1bd5":"0c2bdf6f","chunk-3e468dda":"81c5ccf9","chunk-4996c934":"6c8462c1","chunk-69d9c74a":"e2ec689e","chunk-2d0aa92a":"9067d336","chunk-6ed222af":"863e910e","chunk-02a86be3":"fe549c7a","chunk-6f1d2c20":"85eade91","chunk-817de328":"e777c32b","chunk-05b05314":"42875ba4","chunk-204df1c0":"e4da8f38","chunk-5fc07502":"767df11d","chunk-104b8cdc":"17fac30a","chunk-48ccf842":"7d915b41","chunk-7e073658":"dea36a4d","chunk-c81a5e2e":"d303d085","chunk-380def68":"13f2e3d4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"about~privacy":1,"about":1,"privacy":1,"account":1,"chunk-0ed068c3":1,"chunk-71fbe8a7":1,"chunk-9e48a706":1,"chunk-c3a6b34c":1,"chunk-747bbab8":1,"btc-ghs~dashboard":1,"btc-ghs":1,"dashboard":1,"eth-xof":1,"pm-cfa":1,"register":1,"exchange":1,"chunk-d036161e":1,"faq":1,"funds":1,"home":1,"terms":1,"chunk-608a2038":1,"chunk-586e5fad":1,"chunk-74e97a69":1,"chunk-9d75d2e6":1,"chunk-9e6a327e":1,"chunk-221b05e2":1,"chunk-0f60b37e":1,"chunk-7b0a01d1":1,"chunk-140e1bd5":1,"chunk-3e468dda":1,"chunk-4996c934":1,"chunk-69d9c74a":1,"chunk-6ed222af":1,"chunk-02a86be3":1,"chunk-6f1d2c20":1,"chunk-817de328":1,"chunk-05b05314":1,"chunk-204df1c0":1,"chunk-5fc07502":1,"chunk-104b8cdc":1,"chunk-48ccf842":1,"chunk-7e073658":1,"chunk-c81a5e2e":1,"chunk-380def68":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about~privacy":"about~privacy","about":"about","privacy":"privacy","account":"account","btc-ghs~dashboard":"btc-ghs~dashboard","btc-ghs":"btc-ghs","dashboard":"dashboard","eth-xof":"eth-xof","pm-cfa":"pm-cfa","register":"register","exchange":"exchange","faq":"faq","funds":"funds","home":"home","terms":"terms"}[chunkId]||chunkId) + "." + {"about~privacy":"2dee0201","about":"7831872f","privacy":"d1597934","account":"b9e8693e","chunk-0ed068c3":"f72f95a4","chunk-71fbe8a7":"647f3f0c","chunk-9e48a706":"9919cd71","chunk-c3a6b34c":"686a8dbf","chunk-747bbab8":"326a74be","btc-ghs~dashboard":"c431b790","btc-ghs":"bfba64b1","dashboard":"ee8d44a0","eth-xof":"ba89f25b","pm-cfa":"6931c378","register":"13fe61f2","exchange":"3b080a17","chunk-d036161e":"ec0f3f43","faq":"d1597934","funds":"e3181588","home":"a4e1792e","terms":"d1597934","chunk-608a2038":"62f933d4","chunk-586e5fad":"76d934c6","chunk-2d237773":"31d6cfe0","chunk-74e97a69":"b69e213f","chunk-9d75d2e6":"d8bb358b","chunk-9e6a327e":"4a33e49e","chunk-221b05e2":"4b4932a1","chunk-0f60b37e":"b35c1715","chunk-7b0a01d1":"bb706cbd","chunk-140e1bd5":"462faa96","chunk-3e468dda":"c2bebf97","chunk-4996c934":"5daff5f9","chunk-69d9c74a":"2499eb38","chunk-2d0aa92a":"31d6cfe0","chunk-6ed222af":"be0e415c","chunk-02a86be3":"0480314f","chunk-6f1d2c20":"8c245cdb","chunk-817de328":"ca6ac563","chunk-05b05314":"5e8bf325","chunk-204df1c0":"de4986de","chunk-5fc07502":"4a9ff045","chunk-104b8cdc":"136d3071","chunk-48ccf842":"6edd2ac2","chunk-7e073658":"392c5a75","chunk-c81a5e2e":"431ccc13","chunk-380def68":"8884b9ee"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
